'use strict';
angular.module('cvsApp').controller('directionController', ['$scope', 'webTrendsService', function($scope, WTS) {
    var utagObj = {};
    utagObj.page_name = "Store Directions";
    utagObj.page_category = "Store Directions";
    WTS.webTrendsUtag("OBJ", utagObj);
    }
]);